import type { DataViewController } from "~/views/viewController";
import type { DataViewState } from "~/views/viewDefinition";

export type ProjectTaskSurfaceView = "backlog" | "list" | "board" | "timeline";

export function isProjectTaskBacklogView(state: DataViewState): boolean {
  return state.layout === "list" && state.statusFilter === "backlog";
}

export function projectTaskSurfaceView(state: DataViewState): ProjectTaskSurfaceView {
  return isProjectTaskBacklogView(state) ? "backlog" : state.layout;
}

export function setProjectTaskSurfaceView(
  controller: DataViewController,
  view: ProjectTaskSurfaceView,
): void {
  if (view === "backlog") {
    controller.patchState({ layout: "list", statusFilter: "backlog", taskGroupBy: "milestone" });
    return;
  }
  controller.patchState({
    layout: view,
    ...(isProjectTaskBacklogView(controller.state) ? { statusFilter: "" } : {}),
  });
}
